import { type Registry as Services, service } from '@ember/service';
import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type CustomerModel from 'uplisting-frontend/models/customer';
import { BillingQuoteCurrency } from 'uplisting-frontend/models/billing-quote';

export default class CustomerRepositoryService extends BaseRepositoryService<CustomerModel> {
  @service session!: Services['session'];

  recordName = 'customer';
  implementMethods = ['createRecord', 'peekRecord', 'findRecord'];

  get defaultParams() {
    return {
      currency: BillingQuoteCurrency.USD,
      annual: true,
      user: this.session.currentUser,
    };
  }

  public getDefaultRecord(): CustomerModel {
    return this.peekRecord('me') ?? this.createRecord(this.defaultParams);
  }
}

declare module '@ember/service' {
  interface Registry {
    'repositories/customer': CustomerRepositoryService;
  }
}
